exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".logReadingModal .modal-dialog{width:725px}.logReadingModal .modal-body{min-height:300px}.logReadingModal .modal-body .modalAction{text-align:center}.logReadingModal .modal-body .resetSearch{margin-left:10px;cursor:pointer}.logReadingModal .modal-body .dailyMinutesMaxErrorText{font-size:.8em;color:#a1011e;margin-left:80px;position:relative;bottom:10px}.logReadingModal .modal-body .studentsSelectedSection{margin-left:67px}.logReadingModal .smartBookSearch{width:75%;margin-left:12.5%;margin-bottom:15px}.logReadingModal .smartBookSearch .searchBar{margin-left:27px}.logReadingModal .showBookSearch{position:absolute;right:100px;bottom:23px;font-size:.8em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/reading/books/log_reading_modal.scss
// module id = 1356
// module chunks = 0